import { Button, Paper, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import StorylineServerProxy from "../storyline-proxy/storyline-proxy";

export function GARExtraLinksList(){

    let [title, setTitle] = useState("");
    let [link, setLink] = useState("");

    let [extraLinks, setExtraLinks] = useState([]);

    function handleLinkChanged(event: any){
        setLink(event.target.value);
    }

    function handleTitleChanged(event: any){
        setTitle(event.target.value);
    }

    function handleAddClicked(){
        StorylineServerProxy.addExtraLink({ link: link, title: title, timestamp: new Date().getTime()})?.then(() => {
            setTitle("");
            setLink("");
            loadExtraLinks();
        });
    }

    function handleDeleteClicked(link){
        StorylineServerProxy.deleteExtraLink(link)?.then(() => { loadExtraLinks() });
    }

    function loadExtraLinks(){
        StorylineServerProxy.allExtraLinks()?.then(links => {
            setExtraLinks(links);
        })
    }

    useEffect(loadExtraLinks, []);

    return (
        <>
            <Paper sx={{ padding: 1}} elevation={6}>
                <TextField sx={{width: 1/1}} value={link} onChange={handleLinkChanged} placeholder="https://www.examples.com"></TextField>
                <br/>
                <TextField sx={{width: 1/1}} value={title}onChange={handleTitleChanged}  placeholder="Put title here..."></TextField>
                <br />
                <Button onClick={handleAddClicked}>Add</Button>
            </Paper>
            <Paper sx={{ padding: 1}} elevation={6}>
                {
                    extraLinks.map(extraLink => {
                        return (
                            <Paper elevation={6} sx={{padding: 1}}>                          
                                { extraLink.title }
                                <br />
                                { extraLink.link }
                                <br />
                                <Button onClick={() => { handleDeleteClicked(extraLink.link)}}>Delete</Button>
                            </Paper>
                        )
                    })
                }
            </Paper>
        </>
    )
}
